import { AppState } from '@app/ngrx/app-state/app-state';
import { createSelector } from '@ngrx/store';
import { adapter } from '@app/ngrx/real-property-data/reducers';

export const getRealPropertyMapState = (state: AppState) => state.realPropertyMapData;
export const getRealPropertyMapCollection = adapter.getSelectors(getRealPropertyMapState).selectAll;
export const getRealPropertyMapDataLoading = createSelector(getRealPropertyMapState, (state) => state.loading);
